module.exports = __webpack_public_path__ + "static/media/2764.c602aeed.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/twemoji/2764.svg
 ** module id = 273
 ** module chunks = 0
 **/